import { useQuery } from 'react-query'

// Libs
import { fetchNotificationList } from '@/api/fetchNotificationList'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

// Types
export type NotificationItem = {
  id: string
  content: string
  enablePush: boolean
  targetRule: string
  isRead: boolean
  actualSentAt: string
  startAt: string
  title: string
}

export type NotificationListResponse = {
  notification: NotificationItem[]
  totalPage: {
    totalPages: number
    totalCount: number
  }
}

interface IParams {
  pageSize?: number
  pageNo?: number
  enabled?: boolean
}

export const useNotificationList = (params?: IParams) => {
  const { pageSize = 10, pageNo = 1, enabled = true } = params || {}

  const { data, isLoading, isFetching, refetch, isSuccess } = useQuery<NotificationListResponse>(
    [QUERY_KEY.FETCH_NOTIFICATION_LIST, { pageSize, pageNo }],
    () => fetchNotificationList({ pageSize, pageNo }),
    {
      enabled,
    },
  )

  return {
    notificationList: data?.notification || [],
    totalPage: data?.totalPage,
    isLoading,
    isFetching,
    refetch,
    isSuccess,
  }
}
